import { bm25Search } from './bm25.js';
import { expandText, GROUP_EXPAND } from '../common/synonyms.js';
/**
 * Everything derived from a raw query, computed once and shared by all stages.
 * Stages read `lexicalResults` / `rawResults` (already BM25-scored) rather than
 * re-running BM25, and read `boostTokens` / `fullQuery` for the title-boost.
 */
export class QueryContext {
    raw;
    /** `raw` lowercased + trimmed — used for the exact description title-boost. */
    fullQuery;
    /** Synonym-expanded query text, used as the BM25 query string. */
    expandedQuery;
    /** Curated-expanded tokens used to boost docs whose title contains them. */
    boostTokens;
    bm25Limit;
    weights;
    limit;
    /** BM25 hits for the expanded query (candidate pool + score basis). */
    lexicalResults;
    /** BM25 hits for the raw query — used to flag synonym-only matches. */
    rawResults;
    rawCodes;
    maxLex;
    constructor(init) {
        this.raw = init.raw;
        this.fullQuery = init.fullQuery;
        this.expandedQuery = init.expandedQuery;
        this.boostTokens = init.boostTokens;
        this.bm25Limit = init.bm25Limit;
        this.weights = init.weights;
        this.limit = init.limit;
        this.lexicalResults = init.lexicalResults;
        this.rawResults = init.rawResults;
        this.rawCodes = init.rawCodes;
        this.maxLex = init.maxLex;
    }
    /**
     * Build a fully-derived context: normalise, synonym-expand, curated-expand,
     * and run the two BM25 candidate pools (expanded + raw) exactly once.
     */
    static create(text, options, view) {
        const fullQuery = text.toLowerCase().trim();
        const expandedQuery = expandText(text, options.synonymMap);
        const boostTokens = expandText(text, GROUP_EXPAND)
            .toLowerCase()
            .split(/\s+/)
            .filter((t) => t.length > 0);
        const docs = Object.values(view.documents);
        const lexicalResults = bm25Search(expandedQuery, view.invertedIndex, docs, options.bm25Limit);
        const rawResults = bm25Search(text, view.invertedIndex, docs, options.bm25Limit);
        const rawCodes = new Set(rawResults.map((r) => r.code));
        const maxLex = lexicalResults[0]?.score ?? 1;
        return new QueryContext({
            raw: text,
            fullQuery,
            expandedQuery,
            boostTokens,
            bm25Limit: options.bm25Limit,
            weights: options.weights,
            limit: options.limit,
            lexicalResults,
            rawResults,
            rawCodes,
            maxLex,
        });
    }
}
//# sourceMappingURL=query-context.js.map